import { useState, useEffect } from 'react';
import { api } from '../api';
import HelpLink from './help/HelpLink';

export default function ConversationSelector({ caseId, activeId, onSelect }) {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const data = await api.get(`/exploration/case/${caseId}/conversations`);
        if (!cancelled) setConversations(data.conversations || data || []);
      } catch {
        // non-fatal
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [caseId]);

  async function handleNew() {
    onSelect(null); // signals "new conversation"
  }

  async function handleArchive(convId, e) {
    e.stopPropagation();
    try {
      await api.del(`/exploration/case/${caseId}/conversations/${convId}`);
      setConversations(prev => prev.filter(c => c.id !== convId));
      if (activeId === convId) onSelect(null);
    } catch {
      // ignore
    }
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  return (
    <div className="conversation-selector">
      <div className="conversation-header">
        <span className="conversation-title">Conversations</span>
        <button className="btn btn-sm btn-primary" onClick={handleNew}>+ New</button>
      </div>

      {loading && <div className="conversation-loading">Loading…</div>}

      <div className="conversation-list">
        {conversations.map(c => (
          <div
            key={c.id}
            className={`conversation-item ${c.id === activeId ? 'conversation-active' : ''}`}
            onClick={() => onSelect(c.id)}
          >
            <div className="conversation-item-main">
              <span className="conversation-preview">
                {c.status === 'streaming' && <span className="conversation-streaming-dot" title="Streaming">●&nbsp;</span>}
                {c.title || c.last_message?.slice(0, 60) || `Conversation`}
              </span>
              <span className="conversation-date">{formatDate(c.updated_at || c.created_at)}</span>
            </div>
            <button
              className="btn-ghost btn-sm conversation-archive"
              onClick={(e) => handleArchive(c.id, e)}
              title="Archive"
            >
              ×
            </button>
          </div>
        ))}
        {!loading && conversations.length === 0 && (
          <div className="conversation-empty">
            No conversations yet.{' '}
            <HelpLink slug="asking-arc" label="Ask Arc">Learn how Ask Arc works →</HelpLink>
          </div>
        )}
      </div>
    </div>
  );
}
